import { Button } from "reactstrap";
import { changeStepper } from "../../helpers/changeStepper";
import { IStepper } from "../../model/IStepper";

interface IProps {
  stepper: IStepper;
  setStepper: (data: IStepper) => void;
  formik: any;
  setErrorIncompleteFields: (data: boolean) => void;
  setShowErrorsInputs: (data: boolean) => void;
  validate: () => void;
}
export const Stepper = (props: IProps) => {
  return (
    <div className="container-stepper">
      <div className="divider-steps"></div>
      {props.stepper.steps.map((step, index) => (
        <Button
          className={`${index !== 0 && "not-first-step"} step ${
            props.stepper.current >= index + 1 && "is-checked"
          }`}
          key={index}
          onClick={(e) => changeStepper(e, index + 1, props)}
          disabled={!props.formik.dirty && !props.formik.values?.id || !(index + 1 <= props.stepper.current + 1)}
        >
          <span>{step}</span>
        </Button>
      ))}
    </div>
  );
};
